import { useNavigate } from "react-router-dom";
import { expeditionRoutes } from "../../../../../router/routesConstants";
import { BinsVolumeDataInterface } from "../../../../../redux/interfaces/expedition.interface";
import CustomButton from "../../../../../components/CustomButton";
import SvgIcon from "../../../../../helpers/SvgIcon";

function BinsVolumeActionButtons({
  itemId,
}: {
  itemId: string;
  crudData: BinsVolumeDataInterface;
}) {
  const navigate = useNavigate();

  const handleShowBins = () => {
    if (itemId) {
      navigate(`${itemId}/${expeditionRoutes.showBins}`);
    }
  };

  return (
    <div>
      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        tooltipTitle="Vezi binuri"
        onClick={handleShowBins}>
        <SvgIcon type="PACKAGES" fill="white" />
      </CustomButton>
    </div>
  );
}

export default BinsVolumeActionButtons;
